import {
  BAG_ERROR,
  DISMISS_BAG_ERROR,
  FINISH_REMOVE_BAG_ITEM,
  HIDE_RESERVATION_MESSAGE,
  SET_BAG,
  SET_LOADING,
  SHOW_RESERVATION_MESSAGE,
  START_REMOVE_BAG_ITEM
} from "./constants";

export {
  BAG_ERROR,
  BAG_ITEM_DELETE_TRANSITION_END,
  DISMISS_BAG_ERROR,
  FINISH_REMOVE_BAG_ITEM,
  HIDE_RESERVATION_MESSAGE,
  SET_BAG,
  SET_LOADING,
  SHOW_RESERVATION_MESSAGE,
  START_CHECKOUT,
  START_REMOVE_BAG_ITEM
} from "./constants";

export { deleteBagItem, startCheckout } from "./actions";

export {
  getBag,
  getLoading,
  getBagItems,
  getBagSummary,
  getTotalPrice,
  getTotalPriceText,
  getTotalQuantity,
  displayReservationMessage,
  bagError,
  getSellerChanged,
  dismissBagError,
  getUpdated,
  bagItemDeleteTransitionEnd
} from "./selectors";

const initialState = {
  summary: {
    totalPrice: {}
  },
  loading: true
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_BAG: {
      const { bag, messages, sellerChanged } = action.payload;

      return {
        ...state,
        ...bag,
        messages,
        sellerChanged,
        loading: false,
        bagError: false
      };
    }
    case SET_LOADING: {
      return {
        ...state,
        loading: true
      };
    }
    case START_REMOVE_BAG_ITEM: {
      return {
        ...state
      };
    }
    case SHOW_RESERVATION_MESSAGE: {
      return {
        ...state,
        displayReservationMessage: true
      };
    }
    case HIDE_RESERVATION_MESSAGE: {
      return {
        ...state,
        displayReservationMessage: false
      };
    }
    case BAG_ERROR: {
      return {
        ...state,
        bagError: true,
        loading: false
      };
    }
    case DISMISS_BAG_ERROR: {
      return {
        ...state,
        bagError: false
      };
    }
    case FINISH_REMOVE_BAG_ITEM: {
      return {
        ...state,
        lastItemRemoved: action.itemId
      };
    }
    default:
      return state;
  }
};
